import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Mail, Phone, MapPin, Instagram, Twitter, Youtube } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function Contact() {
  const {
    t
  } = useLanguage();
  return <Section id="contact" data-id="element-41">
      <div className="grid md:grid-cols-2 gap-16" data-id="element-42">
        {/* Contact Info */}
        <div data-id="element-43">
          <h2 className="font-display text-5xl md:text-6xl text-white mb-6" data-id="element-44">
            {t.contact.title}{' '}
            <span className="text-brand-accent" data-id="element-45">{t.contact.titleAccent}</span>
          </h2>
          <p className="text-gray-400 text-lg mb-10" data-id="element-46">{t.contact.subtitle}</p>

          <div className="space-y-8 mb-12" data-id="element-47">
            <div className="flex items-start gap-4" data-id="element-48">
              <div className="w-12 h-12 bg-brand-surface flex items-center justify-center rounded text-brand-accent" data-id="element-49">
                <Mail className="w-6 h-6" data-id="element-50" />
              </div>
              <div data-id="element-51">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-52">
                  {t.contact.emailMe}
                </h3>
                <p className="text-gray-400" data-id="element-53">Example@email.com</p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-54">
              <div className="w-12 h-12 bg-brand-surface flex items-center justify-center rounded text-brand-accent" data-id="element-55">
                <Phone className="w-6 h-6" data-id="element-56" />
              </div>
              <div data-id="element-57">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-58">
                  {t.contact.callMe}
                </h3>
                <p className="text-gray-400" data-id="element-59">(555) 123-4567</p>
              </div>
            </div>

            <div className="flex items-start gap-4" data-id="element-60">
              <div className="w-12 h-12 bg-brand-surface flex items-center justify-center rounded text-brand-accent" data-id="element-61">
                <MapPin className="w-6 h-6" data-id="element-62" />
              </div>
              <div data-id="element-63">
                <h3 className="text-white font-bold text-lg mb-1" data-id="element-64">
                  {t.contact.location}
                </h3>
                <p className="text-gray-400 whitespace-pre-line" data-id="element-65">
                  {t.contact.locationAddress}
                </p>
              </div>
            </div>
          </div>

          <div data-id="element-66">
            <h4 className="text-white font-bold uppercase tracking-widest text-sm mb-4" data-id="element-67">
              {t.contact.followMe}
            </h4>
            <div className="flex gap-4" data-id="element-68">
              {[Instagram, Twitter, Youtube].map((Icon, i) => <a key={i} href="#" className="w-10 h-10 border border-white/20 flex items-center justify-center text-white hover:bg-brand-accent hover:text-brand-dark hover:border-brand-accent transition-all duration-300" data-id="element-69">
                  <Icon className="w-5 h-5" data-id="element-70" />
                </a>)}
            </div>
          </div>
        </div>

        {/* Contact Form */}
        <div className="bg-brand-surface p-8 md:p-10 border border-white/5" data-id="element-71">
          <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-72">
            <div data-id="element-73">
              <label htmlFor="name" className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-74">
                {t.contact.form.fullName}
              </label>
              <input type="text" id="name" className="w-full bg-brand-dark border border-white/10 p-4 text-white focus:outline-none focus:border-brand-accent transition-colors placeholder:text-gray-700" placeholder={t.contact.form.namePlaceholder} data-id="element-75" />
            </div>

            <div data-id="element-76">
              <label htmlFor="email" className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-77">
                {t.contact.form.email}
              </label>
              <input type="email" id="email" className="w-full bg-brand-dark border border-white/10 p-4 text-white focus:outline-none focus:border-brand-accent transition-colors placeholder:text-gray-700" placeholder={t.contact.form.emailPlaceholder} data-id="element-78" />
            </div>

            <div data-id="element-79">
              <label htmlFor="phone" className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-80">
                {t.contact.form.phone}
              </label>
              <input type="tel" id="phone" className="w-full bg-brand-dark border border-white/10 p-4 text-white focus:outline-none focus:border-brand-accent transition-colors placeholder:text-gray-700" placeholder={t.contact.form.phonePlaceholder} data-id="element-81" />
            </div>

            <div data-id="element-82">
              <label htmlFor="message" className="block text-xs font-bold uppercase tracking-widest text-gray-500 mb-2" data-id="element-83">
                {t.contact.form.goals}
              </label>
              <textarea id="message" rows={4} className="w-full bg-brand-dark border border-white/10 p-4 text-white focus:outline-none focus:border-brand-accent transition-colors placeholder:text-gray-700" placeholder={t.contact.form.goalsPlaceholder} data-id="element-84"></textarea>
            </div>

            <Button type="submit" className="w-full" size="lg" data-id="element-85">
              {t.contact.form.submit}
            </Button>

            <p className="text-xs text-center text-gray-600 mt-4" data-id="element-86">
              {t.contact.form.disclaimer}
            </p>
          </form>
        </div>
      </div>
    </Section>;
}